export default function createGaugeOptions(name, value) {
    return {
        grid: {
            // right: '20%'
        },

        series: [
            {
                title: {
                    color: "#191D31",
                },
                type: "gauge",
                name: "",
                detail: { formatter: "{value}%" },
                data: [{ value, name }],
            },
        ],
    };
}
